<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="add"
          >新增运营计划</el-button
        >
        <el-button type="primary" size="small" @click="test('CrmPlan')"
          >营销计划定时任务</el-button
        >
        <el-button type="primary" size="small" @click="test('AutoTask')"
          >自动分配导购任务</el-button
        >
      </div>
      <div>
        <el-input
          clearable
          v-model.trim="searchCondition.planName"
          placeholder="请输入名称搜索"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-select
          size="small"
          class="mr10"
          clearable
          placeholder="请选择计划状态"
          v-model="searchCondition.executeState"
          filterable
        >
          <el-option label="未开始" value="notstart"></el-option>
          <el-option label="已结束" value="end"></el-option>
          <el-option label="执行中" value="going"></el-option>
        </el-select>
        <el-select
          size="small"
          class="mr10"
          clearable
          placeholder="请选择计划类型"
          v-model="searchCondition.planType"
          filterable
        >
          <el-option
            v-for="(item, i) in planType"
            :key="i"
            :label="item.itemText"
            :value="item.itemValue"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <!-- <el-button
          type="primary"
          size="small"
          @click="output('queryAllList', '运营计划数据')"
          :loading="isOutputing"
          >导出报表</el-button
        > -->
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planName"
          label="计划名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planType"
          label="计划类型"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.planType === 'new_member'">
              新客转化
            </div>
            <div v-if="scope.row.planType === 'stage_sale'">
              阶段营销
            </div>
            <div v-if="scope.row.planType === 'repurchase_recommendation'">
              复购推荐
            </div>
            <div v-if="scope.row.planType === 'loss_warning'">
              流失预警
            </div>
            <div v-if="scope.row.planType === 'baby_born'">
              宝宝出生
            </div>
            <div v-if="scope.row.planType === 'member_birthday'">
              会员生日
            </div>
            <div v-if="scope.row.planType === 'baby_full_month'">
              宝宝满月
            </div>
            <div v-if="scope.row.planType === 'out_month'">
              出月子
            </div>
            <div v-if="scope.row.planType === 'baby_hundred_days'">
              宝宝百天
            </div>
            <div v-if="scope.row.planType === 'baby_one_year'">
              一周岁
            </div>
            <div v-if="scope.row.planType === 'plus_card'">
              会员累计消费返利
            </div>
            <div v-if="scope.row.planType === 'baby_birthday'">
              宝宝生日
            </div>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="planStartDate"
          label="计划时间"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.planStartDate || scope.row.planEndDate">
              {{ scope.row.planStartDate || '无开始时间' }}至{{ scope.row.planEndDate || '无结束时间' }}
            </div>
              <div v-else>
              未配置时间
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="executeState"
          label="执行状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.executeState === 'notstart'">
              未开始
            </div>
            <div v-if="scope.row.executeState === 'end'">
              已结束
            </div>
            <div v-if="scope.row.executeState === 'going'">
              执行中
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="是否启用"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.enabledState === 'yes'" class="success">
              已启用
            </div>
            <div v-else class="danger">
              已停止
            </div>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-button
                size="small"
                type="text"
                v-if="scope.row.enabledState === 'yes'"
                @click="enabledState(scope.row)"
                >停止</el-button
              >
              <el-button
                size="small"
                type="text"
                @click="enabledState(scope.row)"
                v-else
                >启用</el-button
              >
              <el-button size="small" type="text" @click="del(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      planType: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    // let a = ["a", "d1f", "ddd123"];
    // let b = ["d1f", "a", "ddd123"];

    this.queryList();
    this.$store.dispatch("queryCrmPlanTypet").then(res => {
      this.planType = res.result;
    });
  },
  methods: {
    async test(pop) {
      const { code } = await this.$store.dispatch(`test${pop}`);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
      }
    },
    async queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch("queryCrmPlanList", params);
      const { records, total } = result;

      this.list = records;
      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    edit(row) {
      this.$router.push({
        name: "EditOperationPlan",
        query: {
          planId: row.planId,
          planType: row.planType
        }
      });
    },
    del(row) {
      this.$confirm(" 是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        this.$store.dispatch("delCrmPlanList", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    add() {
      this.$router.push({
        name: "NewOperationPlan"
      });
    },
    enabledState(row) {
      const params = JSON.parse(JSON.stringify(row));
      params.enabledState = params.enabledState === "yes" ? "no" : "yes";
      this.$store.dispatch("editCrmPlanList", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    // 导出excel
    output(funcName, title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then(res => {
            const list = res.result.list.records;
            list.forEach(v => {
              if (v.state === "0") {
                v.state = "待审核";
              } else if (v.state === "1") {
                v.state = "同意";
              } else if (v.state === "2") {
                v.state = "驳回";
              }
            });
            const tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
